import './vendor/awesomplete.css';

import LineChart from './linechart';

var Hogan = require('hogan.js');
var Awesomplete = require('./vendor/awesomplete');

var Utils = require('./utils');
var map = require('./map.js')

import { resultTemplate } from './templates';

var $result = $('#result-wrapper');
var $searchError = $('.search-err');

var options = {
  minChars : 1,
  autoFirst: true,
  maxItems: 5
}

var $input = $('#autocomplete'),
    autocomplete,
    global_data,
    lines,
    lineChart;

function init(data) {
  global_data = data;
  var autocompleteValues = global_data.map(function(d) { return d.name });

  options.list = autocompleteValues;

  autocomplete = new Awesomplete($input[0], options);
  lineChart = new LineChart('#result-wrapper .result-linechart');

  $input.on('awesomplete-selectcomplete', onSelect);
  $input.on(Utils.clickEvent, ()=> {
    Utils.activateMapMode();
  });

  $('.preset').on('click', function() {
    var selection = $(this).attr('data-city');
    $input.val(selection);
    showData(selection);
  });

  $(document).on(Utils.clickEvent, '.result .close', closeResult);
  $(document).keyup(function(e) {
    if (e.keyCode === 27){
      closeResult();
     }   
  });


  $('#autocomplete-form').on('submit', function(evt) {
    evt.preventDefault();
    onSelect();
    //console.log($('#autocomplete').val());
  });
}

function onChange(e,d) {
  var val = $('.awesomplete ul li[aria-selected="true"]').text();
  $input.val(val);
}

function onSelect() {
  var selection = $input.val();
  showData(selection);
}

function showData(selection) {
  var data = global_data.filter(function(d, i) { return d.name == selection })[0];

  if(Utils.isUndefined(data)) {
    return showError('Laut Innenministerium gab es in diesem Ort keine rechtsextremen Demonstrationen');
  }

  var hrefs = Utils.createHrefs(data);

  data.hrefFb = hrefs.hrefFb;
  data.hrefTwitter = hrefs.hrefTwitter;

  $result.html(resultTemplate.render(data));
  lineChart.render(data.hist);

  $result.css('max-height', '500px');

  map.createLocator(data, '.result-locator');
  $('html').addClass('is-tt-exp');
}

function closeResult(){
  $result.css('max-height', 0);
  $input.val('');

  setTimeout(() => {
      $result.empty();
      //map.reset();
      map.resetAllMarkers();
  },200);
}

function showError(err) {
  $searchError.html(err);
  $searchError.fadeIn();
  setTimeout(function() {$searchError.fadeOut()}, 5000);
}

module.exports = {
  init : init
}